module.exports = __webpack_public_path__ + "static/media/29.81cc4656.png";